export default {
	translations: {
		titles: {
			batmanTvShows: "Batman TV Programları"
		},
		placeholders: {
			searchShow: "Program ara"
		}
	}
};